import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/servizi", label: "Servizi" },
  { to: "/prezzi", label: "Prezzi" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/contatti", label: "Contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-beige/80 border-b border-ink/10"
      data-testid="navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center">
          <Logo size="text-2xl" />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors hover:text-coral ${
                  isActive ? "text-coral" : "text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            data-testid="nav-cta-button"
            className="bg-coral text-white rounded-full px-6 py-2.5 text-sm font-semibold hover:bg-[#e04047] transition-colors"
          >
            Bozza gratis
          </Link>
        </div>

        <button
          className="md:hidden text-ink"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-ink/10 bg-beige px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-lg font-medium ${isActive ? "text-coral" : "text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            className="bg-coral text-white rounded-full px-6 py-3 text-center font-semibold mt-2"
            data-testid="mobile-nav-cta"
          >
            Bozza gratis
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
